import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e600eb44"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "signup-form__input-prepend" }
const _hoisted_3 = { class: "signup-form__tip" }

import { useI18n } from 'vue-i18n'

import { RoutePath } from '@/app/types/app/routes'

import useEntityLoading from '@/composables/common/useEntityLoading'
import useSignupFormData from '@/composables/signup/useSignupFormData'
import useSignupSimpleCRUD from '@/composables/signup/useSignupSimpleCRUD'
import useSignupValidation from '@/composables/validations/signup/useSignupValidation'

import AppButton from '@C/ui/button/AppButton.vue'
import AppInput from '@C/ui/form/AppInput.vue'
import AppPhoneInput from '@C/ui/form/AppPhoneInput.vue'
import AppSelectWrapper from '@C/ui/form/AppSelect/AppSelectWrapper.vue'
import SelectItemWithIcon from '@C/ui/form/AppSelect/SelectItemWithIcon.vue'
import PasswordInput from '@C/ui/form/PasswordInput.vue'
import InputTipUsername from '@C/ui/popover/InputTipUsername.vue'
import PasswordValidationTip from '@C/ui/popover/PasswordValidationTip.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupForm',
  setup(__props) {

const { t } = useI18n()

const { isLoading, toggleLoading, LoadingAction } = useEntityLoading()

const {
  formData,
  signupRequestBody,
  turnoverOptions,
  isPhoneValid,
  handlePhoneValidation,
} = useSignupFormData()

// validation
const {
  formErrors,
  touchAll,
  $v: vuelidate,
  isFormValid,
  setServerErrors,
} = useSignupValidation(formData)

const { signup } = useSignupSimpleCRUD()

function handleSignup() {
  touchAll()

  if (!isFormValid.value || !isPhoneValid.value) {
    return
  }

  toggleLoading(LoadingAction.Signup)

  signup(signupRequestBody.value)
    .catch(({ errors }) => {
      if (errors) {
        setServerErrors(errors)
      }
    })
    .finally(() => toggleLoading(LoadingAction.Signup))
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("form", {
    class: "signup-form",
    onSubmit: _withModifiers(handleSignup, ["prevent"])
  }, [
    _createVNode(AppInput, {
      id: "signup-email",
      modelValue: _unref(vuelidate).email.$model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(vuelidate).email.$model) = $event)),
      label: _unref(t)('common.labels.email'),
      type: "email",
      autocomplete: "email",
      name: "email",
      "force-autofocus": "",
      clearable: "",
      "is-error": !!_unref(formErrors).email,
      "error-text": _unref(formErrors).email,
      tabindex: "1",
      "is-required": ""
    }, null, 8, ["modelValue", "label", "is-error", "error-text"]),
    _createVNode(AppInput, {
      modelValue: _unref(vuelidate).companyName.$model,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(vuelidate).companyName.$model) = $event)),
      label: _unref(t)('common.labels.companyName'),
      clearable: "",
      "is-error": !!_unref(formErrors).companyName,
      "error-text": _unref(formErrors).companyName,
      tabindex: "2",
      "is-required": ""
    }, null, 8, ["modelValue", "label", "is-error", "error-text"]),
    _createVNode(AppSelectWrapper, {
      modelValue: _unref(formData).turnover,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).turnover) = $event)),
      options: _unref(turnoverOptions),
      label: _unref(t)('common.labels.turnover'),
      tabindex: "3"
    }, {
      option: _withCtx(({ label }) => [
        _createVNode(SelectItemWithIcon, { label: label }, null, 8, ["label"])
      ]),
      "selected-option": _withCtx(({ label }) => [
        _createTextVNode(_toDisplayString(label), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "options", "label"]),
    _createVNode(AppPhoneInput, {
      modelValue: _unref(formData).phone,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).phone) = $event)),
      label: _unref(t)('common.labels.phone'),
      "is-error": !_unref(isPhoneValid),
      "error-text": _unref(t)('errors.phoneTemplate'),
      tabindex: "4",
      onValidate: _unref(handlePhoneValidation)
    }, null, 8, ["modelValue", "label", "is-error", "error-text", "onValidate"]),
    _createVNode(AppInput, {
      modelValue: _unref(vuelidate).social.$model,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(vuelidate).social.$model) = $event)),
      label: _unref(t)('common.labels.social'),
      clearable: "",
      "is-error": !!_unref(formErrors).social,
      "error-text": _unref(formErrors).social,
      tabindex: "5",
      "is-required": ""
    }, null, 8, ["modelValue", "label", "is-error", "error-text"]),
    _createVNode(InputTipUsername, null, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          id: "signup-username",
          modelValue: _unref(vuelidate).username.$model,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(vuelidate).username.$model) = $event)),
          modelModifiers: { lowercase: true },
          class: "signup-form__input_username",
          label: _unref(t)('common.labels.username'),
          autocomplete: "off",
          name: "username",
          clearable: "",
          "is-error": !!_unref(formErrors).username,
          "error-text": _unref(formErrors).username,
          tabindex: "6",
          "is-required": ""
        }, {
          prepend: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('common.messages.inxy')) + "/ ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "label", "is-error", "error-text"])
      ]),
      _: 1
    }),
    _createVNode(PasswordValidationTip, {
      password: _unref(vuelidate).password.$model
    }, {
      default: _withCtx(() => [
        _createVNode(PasswordInput, {
          id: "signup-password",
          modelValue: _unref(vuelidate).password.$model,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(vuelidate).password.$model) = $event)),
          name: "new-password",
          autocomplete: "new-password",
          "is-error": !!_unref(formErrors).password,
          "error-text": _unref(formErrors).password,
          tabindex: "7",
          "is-required": ""
        }, null, 8, ["modelValue", "is-error", "error-text"])
      ]),
      _: 1
    }, 8, ["password"]),
    _createVNode(AppButton, {
      "is-loading": _unref(isLoading)(_unref(LoadingAction).Signup),
      class: "app-button_lg",
      tabindex: "8"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('common.buttons.signup')), 1)
      ]),
      _: 1
    }, 8, ["is-loading"]),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref(t)('signupPage.formTip')) + " ", 1),
      _createVNode(_component_RouterLink, {
        class: "default-link",
        to: _unref(RoutePath).Login
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.buttons.login')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ], 40, _hoisted_1))
}
}

})